import React from 'react';
import { useTranslation } from 'react-i18next';

export const Contact = () => {
  const { t } = useTranslation();
  
  return (
    <section className="contact">
      <h1>{t('contactPage.title')}</h1>
      <p>{t('contactPage.description')}</p>
      
      <div className="contact-info">
        <h3>{t('companyName')}</h3>
        <p>{t('contactPage.address')}</p>
        <p>{t('contactPage.phone')}</p>
        <p>{t('contactPage.email')}</p>
      </div>
    </section>
  );
};
